<script>

    import { Lightbox } from 'svelte-lightbox';
    import {decode} from "html-entities";

    export let config;
    export let contentID;

    $ : files = loadFiles(contentID);

    function loadFiles(content) {
        return fetch(config.model_root + 'shared/files/load_files.php?c=' + content + '&t=image', {
            method: "GET"
        })
            .then(response => response.json());
    }

</script>

{#await files}
    <p class="text-muted">
        Bilder werden geladen...
    </p>
{:then items}

    <div class="row row-cols-lg-3 row-cols-md-2 row-cols-1">

        {#each items as image}

            {#if image.fthumbnail == 0 && image.fspotlight == 0}
                <div class="col my-3">
                    <div class="gallery-item rounded overflow-hidden">
<!--                        <img src="{config.application_root}files/{image.fpath}" alt="{image.fname}" class="">-->
                        <Lightbox description="{image.fname}" modalClasses="gallery-item-modal">
                            <img src="{config.application_root}files/{image.fpath}" alt="{decode(image.fname)}">
                        </Lightbox>
                        <p class="mt-3 text-darkgreen mb-0" style="font-size: 1.3em">
                            {decode(image.fname)}
                        </p>
                    </div>
                </div>
            {/if}

        {/each}

    </div>

{:catch error}
    <p style="color: red">{error.message}</p>
{/await}

<style>
    .gallery-item img {
        width: 100%;
        height: 210px;
        object-fit: cover;
    }
    .gallery-item img:hover {
        filter: brightness(70%);
    }
</style>
